var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "verHistoricoProveedor",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Ver Historial De Estados")]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c("div", { attrs: { align: "left" } }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass: "h2_title",
                                      staticStyle: {
                                        "margin-top": "12px !important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Ver Historial De Estados Del Producto:\n                    " +
                                          _vm._s(
                                            _vm.selectedNombre +
                                              " [" +
                                              _vm.selectedCodigo +
                                              "]"
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _c("v-divider"),
                                _c("br"),
                                _c(
                                  "v-flex",
                                  {
                                    attrs: { md12: "", layout: "", "mb-3": "" }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs11: "",
                                          sm6: "",
                                          md6: "",
                                          lg5: "",
                                          xl4: "",
                                          "mr-4": ""
                                        }
                                      },
                                      [
                                        _c("v-text-field", {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            label: "Buscar...",
                                            "append-icon": "search"
                                          },
                                          on: { input: _vm.handleSearch },
                                          model: {
                                            value: _vm.filtrobusquedagrilla,
                                            callback: function($$v) {
                                              _vm.filtrobusquedagrilla = $$v
                                            },
                                            expression: "filtrobusquedagrilla"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs10: "",
                                          sm5: "",
                                          md5: "",
                                          lg6: "",
                                          xl3: ""
                                        }
                                      },
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            label:
                                              "Mostrar Solo Cambios de Precios"
                                          },
                                          on: { change: _vm.handleCheck },
                                          model: {
                                            value: _vm.findPrices,
                                            callback: function($$v) {
                                              _vm.findPrices = $$v
                                            },
                                            expression: "findPrices"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { wrap: "" } },
                                  [
                                    _c("MantenedorGrid", {
                                      staticClass: "ag-theme-material",
                                      staticStyle: {
                                        width: "100%",
                                        height: "400px",
                                        "font-family": "'Asap' sans-serif"
                                      },
                                      attrs: { gridOptions: _vm.gridOptions }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }